import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Skin } from '@core/interfaces/skin.interface';
import { SessionService } from '@core/services/session.service';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { ThumbnailGlowSvgComponent } from '../../svg/thumbnail-glow-svg.component';
import { THUMBNAIL_DISPLAY_COUNT } from '../../upgrader.constants';

@Component({
  selector: 'app-upgrader-items-info',
  standalone: true,
  imports: [DecimalPipe, BalanceIconComponent, ThumbnailGlowSvgComponent],
  templateUrl: './upgrader-items-info.component.html',
  styleUrl: './upgrader-items-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgraderItemsInfoComponent {
  protected readonly sessionService = inject(SessionService);

  readonly skins = input.required<Skin[]>();
  readonly price = input<number | null>(null);
  readonly skinName = input<string | null | undefined>(null);
  readonly label = input<string>('items selected');
  readonly variant = input<'default' | 'center'>('default');
  readonly skipFirst = input<boolean>(false);

  // When skipFirst is true, skip the first skin (already shown in big panel)
  protected readonly displayedSkins = computed(() => {
    const start = this.skipFirst() ? 1 : 0;
    return this.skins().slice(start, start + THUMBNAIL_DISPLAY_COUNT);
  });

  protected readonly extraCount = computed(() => {
    // 1 in big panel + thumbnails, or just thumbnails
    const shownCount = this.skipFirst() ? 1 + THUMBNAIL_DISPLAY_COUNT : THUMBNAIL_DISPLAY_COUNT;
    return Math.max(0, this.skins().length - shownCount);
  });

  protected readonly mobileExtraCount = computed(() => {
    const shownCount = this.skipFirst() ? 2 : 1; // 1 in big panel + 1 thumbnail, or just 1 thumbnail
    return Math.max(0, this.skins().length - shownCount);
  });

  protected readonly showPrice = computed(() => this.price() !== null && this.skinName() === null);
}
